/**
 * This function is to be used as a web worker. It must be entirely self-contained and only use es5 features (babel-polyfills are undefined here)
 * only one message is posted from this worker. It's data object will have two properties, day and rate. The day represents the age of a theoretical invoice and the rate is the rate to be charged against that invoice if it is closed on that day or in that day range.
 * This worker expects to receive only one message. The message data object should have an event ("generate_data") and a fee (term_entry)
 *
 * Once the fee calculations are complete a message with the results will be posted back to the spawner of this worker.
 */
export const feeDataWorker = () => {
  //NOTE: anything not inside this function does not appear in the final compiled result
  //NOTE: cannot import functions in a web worker, well we can but they have to be uncompiled. To figure out later if we continue to use web workers
  const MAX_TABLE_ROWS = 121

  const getRate = (fee, day, end = MAX_TABLE_ROWS) => {
    if (fee.type == 'FeeAgeRange') {
      if (fee.range_begin && fee.range_end && day >= Number(fee.range_begin) && day <= Number(fee.range_end)) {
        return fee.value
      } else {
        return 0
      }
    } else if (fee.type == 'FeeTiered') {
      if (fee.range_begin && day >= Number(fee.range_begin) && day <= Number(end + fee.range_increment)) {
        let schedule = {}
        for (let i = 1; i <= end; i++) {
          schedule[i] = { value: Math.ceil((i - fee.range_begin) / fee.range_increment) * fee.value }
          if (schedule[i].value > 1) {
            schedule[i].value = 1
          }
        }
        return schedule[day].value
      } else {
        return 0
      }
    } else if (fee.type == 'FeeRecurring') {
      if (fee.range_begin && fee.range_end && day >= Number(fee.range_begin) && day <= Number(fee.range_end)) {
        return (Number(fee.value) / (fee.days_in_year || 365)) * (day - fee.range_begin + 1)
      } else if (fee.range_begin && !fee.range_end && day >= Number(fee.range_begin) && day <= Number(end)) {
        return (Number(fee.value) / (fee.days_in_year || 365)) * (day - fee.range_begin + 1)
      } else {
        return 0
      }
    }
    return 0
  }

  const generateFeeData = (e) => {
    let fee = e.data.fee
    let data = []
    if (typeof fee.range_begin !== 'number') {
      postMessage({ event: 'data_generated', data: data })
      return
    }
    let startDay = Number(fee.range_begin)
    let endDay = Number(fee.range_end || MAX_TABLE_ROWS)
    for (let i = startDay; i <= endDay; i++) {
      data.push({
        day: fee.type != 'FeeTiered' ? i : i - 1,
        rate: getRate(fee, i, endDay),
      })
    }
    if (fee.type === 'FeeTiered') {
      data.push({
        day: endDay,
        rate: getRate(fee, endDay + 1, endDay + 1),
      })
    }
    for (let i = startDay - 1; i > 0; i--) {
      data.unshift({ day: i, rate: 0 })
    }

    let percents = data
      .map((rate) => Number(rate.rate).toFixed(10))
      .reduce((prev, val) => {
        let toReturn = prev
        let days = data
          .filter((v) => Number(v.rate).toFixed(10) == val)
          .map((f) => Number(f.day))
          .sort((a, b) => a - b)
        toReturn[val] = {
          min: days[0],
          max: days[days.length - 1],
        }
        return toReturn
      }, {})

    percents = Object.keys(percents).map((percent) => {
      return {
        day:
          percents[percent].max == percents[percent].min
            ? percents[percent].min
            : `${percents[percent].min}-${percents[percent].max}`,
        rate: percent,
        id: Math.random(),
      }
    })
    if (fee.type == 'FeeAgeRange' || fee.type == 'FeeOneTime' || (fee.type === 'FeeRecurring' && fee.range_end)) {
      percents.push({
        day: `${data[data.length - 1].day + 1}+`,
        rate: 0,
        id: Math.random(),
      })
    }

    if (
      percents.length > 1 &&
      ((String(percents[0].day).includes('1') && String(percents[1].day).includes('1-')) ||
        percents[0].day == percents[1].day)
    ) {
      percents.shift()
    }

    if (fee.type === 'FeeTiered' && percents[0] && percents[0].day == 0) {
      percents.shift()
    }

    postMessage({ event: 'data_generated', data: percents })
  }

  const messageHandlers = {
    generate_data: generateFeeData,
  }
  self.addEventListener('message', (e) => {
    if (typeof messageHandlers[e.data.event] === 'function') {
      messageHandlers[e.data.event](e)
    }
  })
}
